import React, { Component } from "react"
import styled from "styled-components"
import ReactPopup from "reactjs-popup"
import CloseIcon from "../../resources/img/ui/popup/popup-close-green.svg"
import colors from "../../styles/colors"
import fonts from "../../styles/fonts"
import Select from "react-select"
import ArrowDown from "../../resources/img/ui/arrows/arrow-down.svg"
import { redirectToLocation } from "../../services/locationHelper"
import versions from "../../services/versions"
import { Trans, withTranslation } from "gatsby-plugin-react-i18next"
import Cookies from "universal-cookie"

const contentStyle = {
  margin: "auto",
  border: `2px solid ${colors.green}`,
  background: "#FFF",
  overflow: "hidden",
  position: "relative",
  width: "376px",
  padding: "20px 16px 20px 16px",
};

const contentStyleMobile = {
  margin: "auto 0 0 0",
  background: "#FFF",
  width: "100%",
  border: `1px solid ${colors.green}`,
  overflow: "hidden",
  position: "relative",
  padding: "20px 16px 20px 16px",
};

const overlayStyle = {
  background: 'rgba(248, 245, 243, 0.9)',
  zIndex: 99999999999
};

const overlayStyleMobile = {
  background: 'none',
  zIndex: 99999999999
};

const PopupContent = styled.div`
    padding: 29px 23px 0 23px;
`;

const Close = styled.img`
    float: right;
    cursor: pointer;
    height: 19px;
    width: 19px;
`;

const Title = styled.div`
    color: ${colors.green};
    ${fonts.selfModern};
    font-size: 22px;
    line-height: 32px;
    text-align: center;
`;

const Subtitle = styled.div`
    color: ${colors.mediumGrey};
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.3px;
    ${fonts.helveticaNeueLight};
    text-align: center;
    margin-top: 8px;
    margin-bottom: 24px;
`;

const Delivery = styled.div`
    font-size: 12px;
    line-height: 18px;
    color: ${colors.grey};
    text-align: center;
    margin-top: 8px;
`;

const customStyles = {
  control: (provided) => ({
    ...provided,
    borderRadius: "0",
    border: "1px solid " + colors.green,
    height: "52px",
    boxShadow: "none",
    '&:hover': {
      borderColor: colors.green,
    },
  }),
  singleValue: styles => ({
    ...styles,
    fontSize: "14px",
    color: colors.greyBorders,
    fontFamily: "'Helvetica Neue Light', Arial, sans-serif",
  }),
  option: (provided, state) => ({
    ...provided,
    color: state.isSelected ? colors.green : colors.greyBorders,
    fontFamily: state.isSelected ? "'Helvetica Neue Medium', Arial, sans-serif" : "'Helvetica Neue Light', Arial, sans-serif",
    backgroundColor: colors.white,
    fontSize: '14px',
    lineHeight: '18px',
  }),
  menu: styles => ({
    ...styles,
    fontSize: "14px",
    border: "1px solid " + colors.green,
    borderRadius: "none",
    marginBottom: '0',
    borderBottom: 'none',
    boxShadow: 'none',
  }),
  indicatorSeparator: styles => ({...styles, display: "none"}),
  dropdownIndicator: styles => ({...styles, display: "none"}),
  indicatorsContainer: (provided) => ({
    ...provided,
    background: "url(" + ArrowDown + ") no-repeat",
    backgroundSize: "10px 6px",
    backgroundPosition: "right 10px center",
    width: "20px",
  }),
};

class LocationPopup extends Component {
  state = {
    width: 0,
    height: 0,
    isOpen: false,
    currentVersion: versions.uk
  };

  closePopup(e) {
    e.preventDefault();

    this.closeModal();
  }

  changeVersion = (code) => {
    const alternatePath = this.props.alternatePath
    let toPath = alternatePath
    const hasDifferentPathPerLocale = Array.isArray(alternatePath)
    const websiteUrl = process.env.WEBSITE_URL

    if (hasDifferentPathPerLocale) {
      if (code === "us") {
        const foundPath = alternatePath.find(
          (url) =>
            !url.includes("/eu/") &&
            !url.includes("/uk/") &&
            !url.includes("/fr/")
        )
        toPath = foundPath ? foundPath.replace(websiteUrl, "") : null
      } else {
        const foundPath = alternatePath.find((url) => url.includes(`/${code}/`))
        toPath = foundPath
          ? foundPath.replace(websiteUrl, "").replace(`/${code}`, "")
          : null
      }
    }
    redirectToLocation(code, true, toPath, hasDifferentPathPerLocale)
  }

  getNextYear = () => {
    const current = new Date()
    const nextYear = new Date()
    nextYear.setFullYear(current.getFullYear() + 1)
    return nextYear
  }

  closeModal() {
    const cookies = new Cookies()
    const activeEnv = process.env.GATSBY_ACTIVE_ENV || "us"

    cookies.set("country", activeEnv, {
      path: "/",
      expires: this.getNextYear(),
    })

    this.props.handlePopup(false);
  }

  getContentStyle = () => {
    if (this.state.width >= 700) {
      return contentStyle
    } else if (this.state.width < 700) {
      return contentStyleMobile
    }
  };

  componentDidMount = () => {
    if (typeof window !== "undefined") {
      this.updateWindowDimensions();
      window.addEventListener("resize", this.updateWindowDimensions);

      const activeEnv = process.env.GATSBY_ACTIVE_ENV || "us";
      const activeVersion = versions[activeEnv];

      if (activeVersion) {
        this.setState({currentVersion: activeVersion})
      }
    }
  };

  componentWillUnmount = () => {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.updateWindowDimensions);
    }
  };

  updateWindowDimensions = () => {
    if (typeof window !== "undefined") {
      this.setState({width: window.innerWidth, height: window.innerHeight})
    }
  };

  render() {
    const {isOpen,t} = this.props;
    const {currentVersion} = this.state;
    const {changeVersion} = this;

    const options = {};

    for (const key in versions) {
      options[key] = {
        value: versions[key].code,
        label: versions[key].name + " ( " + versions[key].currency + " )",
      }
    }

    return (
      <ReactPopup
        open={isOpen}
        onClose={() => this.closeModal()}
        closeOnDocumentClick
        contentStyle={this.getContentStyle()}
        overlayStyle={this.state.width >= 700 ? overlayStyle : overlayStyleMobile}>
        <>
          <Close onClick={(e) => this.closePopup(e)} src={CloseIcon}/>
          <PopupContent>
            <Title>
              <Trans i18nKey={'location.version'}>
                You are visiting the Kimaï {currentVersion.name} Website
              </Trans>

            </Title>
            <Subtitle>{t('location.change')}</Subtitle>
            <Select options={Object.values(options)}
                    defaultValue={options[currentVersion.code]}
                    value={options[currentVersion.code]}
                    onChange={(option) => changeVersion(option.value)}
                    styles={customStyles}
                    menuPlacement="top"/>
            <Delivery>{t('location.terms')}</Delivery>
          </PopupContent>
        </>
      </ReactPopup>
    )
  }
}

export default withTranslation()(LocationPopup);
